export const lamejsWorker = new Worker(
  new URL('../workers/audio-channel-to-mp3-worker.ts', import.meta.url),
  { type: 'module' },
)
